import { useState } from "react"
import { createAgent } from "../../../../services/api" // adjust the path if needed

const AgentEntryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    address: "",
    
  })

  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" })
    }
  }



  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) newErrors.name = "Name is required"
    if (!formData.number.trim()) newErrors.number = "Number is required"
    else if (!/^\d{10}$/.test(formData.number)) newErrors.number = "Must be 10 digits"

    if (!formData.address.trim()) newErrors.address = "Address is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return

    setLoading(true)

    try {

      const submitData = {
        ...formData,
        
      }

      const response = await createAgent(submitData)
      console.log("response: ", response)

      alert("Agent created successfully!")
      setFormData({
        name: "",
        number: "",
        address: "",
       
      })
      setErrors({})
    } catch (error) {
      console.error(error)
      alert(error || "Failed to create agent")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-white p-6 border border-gray-200 shadow-lg rounded-xl">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Add New Agent</h2>

      <div className="space-y-6">
        {/* Name */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Name *</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`w-full p-2.5 border rounded-md focus:outline-none ${
              errors.name ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
        </div>

        {/* Number */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Phone Number *</label>
          <input
            name="number"
            value={formData.number}
            onChange={handleChange}
            className={`w-full p-2.5 border rounded-md focus:outline-none ${
              errors.number ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.number && <p className="text-red-500 text-xs">{errors.number}</p>}
        </div>

        {/* Address */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Address *</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            className={`w-full p-2.5 border rounded-md focus:outline-none ${
              errors.address ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.address && <p className="text-red-500 text-xs">{errors.address}</p>}
        </div>

     

        {/* Submit */}
        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading}
          className={`w-full py-3 rounded-md font-medium text-white transition-colors ${
            loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-800 hover:bg-gray-700'
          }`}
        >
          {loading ? "Saving..." : "Save Agent"}
        </button>
      </div>
    </div>
  )
}

export default AgentEntryForm
